/*
  Displays all billing plans (ie. rate schedules) based on parameters.
  Encapsulates all logic to render the additional charges modal as well.
  Can handle displaying multiple rate schedule cards.

  // shows default plans - good for landing/marketing pages
  <rate-schedule-cards></rate-schedule-cards>

  //shows a specific rate schedule based on passed rate_schedule_id
  <rate-schedule-cards
    rateScheduleId=123
  ></rate-schedule-cards>  

  // shows plans associated with the group.
  // if it is a custom plan, then only that is shown,
  // otherwise all default plans are shown with the selected plan highlighted
  <rate-schedule-cards
    groupId=123
  ></rate-schedule-cards>

*/

import {RateScheduleCardBase} from 'admin/accounting/rate_schedule_card_base'

export class RateScheduleCards extends HTMLElement {
  constructor() {
    super();
  }


  async loadData(){
    this.rateScheduleId = this.getAttribute('rateScheduleId');
    this.showCurrentPlan = this.getAttribute('showCurrentPlan') || false;
    this.groupId = this.getAttribute('groupId');
    let url = `/admin/rate_schedules/${this.rateScheduleId}/card_editor_data`
    // if group id is present, attempt to load real group data
    if (this.groupId){
      url = `/admin/groups/${this.groupId}/rate_schedule_cards`
    }

    let res = await fetch(url);
    this.data = await res.json();
    // console.log('RateScheduleCards data: ',this.data)
  }
  
  async connectedCallback() {
    await this.loadData()
    this.innerHTML = `
      <div class="row">
        <template id="additional_charges_template">      
          <div class="content">
            <table class="pricing-table">
              <colgroup>
                <col class="col-headers" />
                <col class="col-data" />
              </colgroup>
              <thead>
                <tr>
                  <td class="info">
                    <p class="title"></p>
                  </td>
                  <th scope="col">
                    <p class="tier">
                      Starting at <span class="price"></span>
                    </p>
                    <p>
                      Monthly fee plus<br />additional usage.
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </template>

        <div class="billing_plans_container"></div>
      </div>

      <additional-charges-modal></additional-charges-modal>
      `;


    const billing_plans_container = this.querySelector('.billing_plans_container');
    if (billing_plans_container){
      this.data.map(rate_schedule => {
        rate_schedule['show_current_plan'] = this.showCurrentPlan
        billing_plans_container.appendChild(new RateScheduleCard(rate_schedule))        
      })
    }
  }  // connectedCallback
}
customElements.define("rate-schedule-cards", RateScheduleCards)

// Represents an individual rate schedule card
// plan should be renamed to rate_schedule 
// autoGroupHasSelectedRateSchedule used to indicate if the auto group associated with
// the RateScheduleCard has already selected a rate schedule. Maybe use to render cards
// differently.
export class RateScheduleCard extends RateScheduleCardBase{
  constructor(rate_schedule, upgradable=false, autoGroupHasSelectedRateSchedule=false, differentCollectionSelected=false) {
    super(rate_schedule, upgradable, autoGroupHasSelectedRateSchedule, differentCollectionSelected);
  }
 
  connectedCallback() {
    this.populate_inner_html_template()

    // listener to show the additional charges modal
    this.querySelector(".additional_fees").addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // needed to prevent clicks on the lower elements like pricing-card 
      const template = this.querySelector('#modal_template');
      const node = template.content.cloneNode(true)
      document.querySelector("additional-charges-modal").show(this.rateSchedule.data.rate_schedule_name, node)
    }.bind(this));
  }
}
customElements.define("rate-schedule-card", RateScheduleCard)


/*
  Acts as a dummy rate schedule card but has no backing data.
*/
export class EnterpriseRateScheduleCard extends HTMLElement{
  constructor(call_us_number) {
    super();
    this.call_us_number = call_us_number || "No number provided"
  }

  generate_call_to_action_button() {
    let html = `<a 
      title="Click to call us."
      class="enterprise-billing-plan btn btn-primary" 
      href="tel:${this.call_us_number}">Call Us</a>`
    
    return html;
  }

  connectedCallback(){
    const ctaButton = this.generate_call_to_action_button();

    this.innerHTML = `
    <div class="pricing-card-container enterprise"}>
      <div class="pricing-card">

        <h2 class="title">Enterprise</h2>
        <p class="description"></p>

        <div>
          <span class="price">Custom Pricing</span>
          <span class="additional-usage">Plans Tailored To Your Needs</span>
        </div>

        <div class="info">
        </div>

        ${ctaButton}

      </div>
    </div>
    `  
  }
}
customElements.define("enterprise-rate-schedule-card", EnterpriseRateScheduleCard)


// this is the popup modal to show additional charges
export class AdditionalChargesModal extends HTMLElement {
  constructor() {
    super();
  }

  show(planName, node){
    this.reset();
    this.querySelector('#billing_plan_name').textContent = planName;
    this.querySelector('.modal-body').appendChild(node);
    $('#additionalChargesModal').modal("show")
  }

  async connectedCallback() {
    this.innerHTML = `
      <div class="modal fade" id="additionalChargesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title"><span id="billing_plan_name"></span> Plan Details</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              

            </div>
          </div>
        </div>
      </div>`;


    $(this).find('.modal').on('hidden.bs.modal', function () {
      this.reset();
    }.bind(this));

    this.reset()   
  }
  
  reset(){
    this.querySelector('.modal-body').innerHTML = ``
  }
  
}
customElements.define("additional-charges-modal", AdditionalChargesModal)
